import { render } from "./EmojiAndMediaPicker.vue?vue&type=template&id=f1e7d480&scoped=true"
import script from "./EmojiAndMediaPicker.vue?vue&type=script&lang=js"
export * from "./EmojiAndMediaPicker.vue?vue&type=script&lang=js"

import "./EmojiAndMediaPicker.vue?vue&type=style&index=0&id=f1e7d480&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1e7d480"]])

export default __exports__